import axios from "~/services/api";
import { AnyRecord } from "~/types/record"

export type SendLogResponse = any;
export type SendLogRequest = { data: AnyRecord };

export async function sendLog({ data }: SendLogRequest): Promise<SendLogResponse> {
    return axios.post(`/v1/log`, data).then(res => res.data);
}
